import { API_PATH } from '../const/api_paths'
import { getBearerToken, removeAuthToken } from './_auth';

export const doGet = function (endpoint, data, callback = {}) {
  var headers = {
    method:   "GET",
    mode:     "cors",
    cache:    "no-cache",
    headers:  {"Content-Type": "application/json"},
    body:     JSON.stringify(data)
  }
  doFetch(endpoint, headers, callback)
}

export const doPost = (endpoint, data, callback = {}) => {
  var options = {
    method:   "POST",
    mode:     "cors",
    cache:    "no-cache",
    headers:  {"Content-Type": "application/json"},
    body:     JSON.stringify(data)
  }
  doFetch(endpoint, options, callback)
}

export const doPostWithHeaders = (endpoint, data, callback = {}) => {
  var options = {
    method:   "POST",
    headers:  {'Accept': 'application/json','Content-Type': 'application/json'},
    body:     JSON.stringify(data)
  }
  doFetchWithHeaders(endpoint, options, callback)
}

export const doAuthenticatedGet = (endpoint, data, callback = {}) => {
  const windowGlobal = typeof window !== 'undefined' && window
  var token = windowGlobal.localStorage.getItem('billebotAuthToken')
  var headers = new Headers()
  headers.append("Accept", "application/json")
  headers.append("Content-Type", "application/json")
  headers.append("Authorization", `Bearer ${token}`)

  var options = {
    method:   "GET",
    mode:     "cors",
    cache:    "no-cache",
    headers:  headers,
  }
  doFetch(addQueryString(endpoint, data), options, callback)
}

export const doAuthenticatedPost = (endpoint, data, callback = {}) => {
  const windowGlobal = typeof window !== 'undefined' && window
  var token = windowGlobal.localStorage.getItem('billebotAuthToken')
  var headers = new Headers()
  headers.append("Content-Type", "application/json")
  headers.append("Authorization", `Bearer ${token}`)

  var options = {
    method:   "POST",
    mode:     "cors",
    cache:    "no-cache",
    headers:  headers,
    body:     JSON.stringify(data),
  }
  doFetch(endpoint, options, callback)
}

export const doAuthenticatedPostFormData = (endpoint, form_data, callback = {}) => {
  const windowGlobal = typeof window !== 'undefined' && window
  var token = windowGlobal.localStorage.getItem('billebotAuthToken')
  var headers = new Headers()
  // headers.append("Accept", "application/json")
  // headers.append("Content-Type", "application/x-www-form-urlencoded")
  headers.append("Authorization", `Bearer ${token}`)

  var options = {
    method:   "POST",
    // mode:     "cors",
    // cache:    "no-cache",
    headers:  headers,
    body:     form_data
  }
  doFetch(endpoint, options, callback)
}

export const doAuthenticatedPutFormData = (endpoint, form_data, callback = {}) => {
  const windowGlobal = typeof window !== 'undefined' && window
  var token = windowGlobal.localStorage.getItem('billebotAuthToken')
  var headers = new Headers()
  headers.append("Authorization", `Bearer ${token}`)

  var options = {
    method:   "PUT",
    mode:     "cors",
    cache:    "no-cache",
    headers:  headers,
    body:     form_data
  }
  doFetch(endpoint, options, callback)
}

export const doAuthenticatedPut = (endpoint, data, callback = {}) => {
  const windowGlobal = typeof window !== 'undefined' && window
  var token = windowGlobal.localStorage.getItem('billebotAuthToken')
  var headers = new Headers()
  headers.append("Content-Type", "application/json")
  headers.append("Authorization", `Bearer ${token}`)

  var options = {
    method:   "PUT",
    mode:     "cors",
    cache:    "no-cache",
    headers:  headers,
    body:     JSON.stringify(data)
  }
  doFetch(endpoint, options, callback)
}

export const doAuthenticatedDelete = (endpoint, data, callback = {}) => {
  const windowGlobal = typeof window !== 'undefined' && window
  var token = windowGlobal.localStorage.getItem('billebotAuthToken')
  var headers = new Headers()
  headers.append("Content-Type", "application/json")
  headers.append("Authorization", `Bearer ${token}`)

  var options = {
    method:   "DELETE",
    mode:     "cors",
    cache:    "no-cache",
    headers:  headers,
    body:     JSON.stringify(data)
  }
  doFetch(endpoint, options, callback)
}

export const getSessionExpiredRedirect = () => {
  return '/?session_expired=true';
};

export const doFetch = (endpoint, headers, callback) => {
  fetch(addTimestamp(API_PATH(endpoint)), headers)
  .then(res => res.json())
  .then(res=> {
    if(res.status === "ok" || res.status === "success") {
      if(callback.success) { callback.success(res) }
    } else if (
      res.error === "You need to sign in or sign up before continuing." ||
      res.error === "Not enough or too many segments" ||
      res.error === "Signature has expired"
    ) {
      removeAuthToken()
      window.location = getSessionExpiredRedirect()
    } else if(res.status === "error" || res.error) {
      if(callback.error) { callback.error(res) }
    } else {
      if(callback.general) { callback.general(res) }
    }
  })
  .catch(res => {
    if(callback.catch) { callback.catch(res) }
  })
}

export const doFetchWithHeaders = (endpoint, headers, callback) => {
  var local_headers = {};
  fetch(API_PATH(endpoint), headers)
  .then(res => {
    local_headers = res.headers;
    return res.json()
  })
  .then(res=> {
    if(res.status === "ok" || res.status === "success") {
      if(callback.success) {
        callback.success({...res, headers: local_headers})
      }
    } else if (
      res.error === "You need to sign in or sign up before continuing." ||
      res.error === "Not enough or too many segments" ||
      res.error === "Signature has expired"
    ) {
      removeAuthToken()
      window.location = getSessionExpiredRedirect()
    } else if(res.status === "error" || res.error) {
      if(callback.error) { callback.error(res) }
    }
  })
  .catch(res => {
    if(callback.catch) { callback.catch(res) }
  })
}


// Opens an authenticated file endpoint in a new tab.
//
// A bare window.open cannot carry the bearer token, which is why several endpoints used to
// take the caller's identity from a base64 `?n=` query param instead. Fetch the bytes with
// the Authorization header and hand the browser a blob URL.
export const doAuthenticatedOpenFile = (endpoint, callback = {}) => {
  // Claim the tab synchronously, still inside the click handler's call stack. A window.open
  // deferred into the fetch's .then() reads as a popup and gets blocked.
  const tab = window.open("", "_blank");

  fetch(API_PATH(endpoint), {
    method:  "GET",
    mode:    "cors",
    cache:   "no-cache",
    headers: { "Authorization": getBearerToken() },
  })
  .then(res => {
    if (res.status === 401) {
      if (tab) { tab.close() }
      removeAuthToken()
      window.location = getSessionExpiredRedirect()
      return null
    }
    if (!res.ok) {
      if (tab) { tab.close() }
      if (callback.error) { callback.error(res) }
      return null
    }
    return res.blob()
  })
  .then(blob => {
    if (!blob) { return }
    const url = window.URL.createObjectURL(blob)
    if (tab) { tab.location = url } else { window.open(url, "_blank") }
    // Give the new tab time to load before releasing the object URL.
    window.setTimeout(() => window.URL.revokeObjectURL(url), 60000)
    if (callback.success) { callback.success() }
  })
  .catch(err => {
    if (tab) { tab.close() }
    if (callback.catch) { callback.catch(err) }
  })
}

// DISABLED — kept for when the backend stops requiring auth on the report endpoints.
//
// Fetching a report with the bearer token and saving the bytes as a blob works locally but
// not against the deployed API, so every download went back to a plain `window.location`
// navigation for now. The agreed fix is to skip authentication on the report actions
// themselves; re-enable this helper once a download can carry the header end to end.
//
// // Reads the filename the server chose for a download.
// //
// // Rack::Cors must list Content-Disposition in its `expose` for this header to be visible
// // cross-origin at all; when it is not (an older API host), the caller's fallback is used.
// const filenameFromResponse = (res, fallback) => {
//   const disposition = res.headers.get("Content-Disposition")
//   if (!disposition) { return fallback }
//
//   // filename* (RFC 5987) carries non-ASCII names — firm and account names reach these
//   // filenames — so prefer it over the plain filename when the server sends both.
//   const encoded = /filename\*=UTF-8''([^;]+)/i.exec(disposition)
//   if (encoded) {
//     try { return decodeURIComponent(encoded[1]) } catch (err) { /* fall through */ }
//   }
//
//   const plain = /filename="?([^";]+)"?/i.exec(disposition)
//   return plain ? plain[1] : fallback
// }
//
// const saveBlob = (blob, filename) => {
//   const url = window.URL.createObjectURL(blob)
//   const link = document.createElement("a")
//   link.href = url
//   link.download = filename
//   document.body.appendChild(link)
//   link.click()
//   link.remove()
//   window.URL.revokeObjectURL(url)
// }
//
// // Pulls a readable message out of a refused download's body, which may be JSON
// // ({error} or {errors}) or bare text depending on which controller refused.
// const downloadErrorMessage = (body) => {
//   try {
//     const parsed = JSON.parse(body)
//     const message = parsed.error || (Array.isArray(parsed.errors) ? parsed.errors.join(" ") : parsed.errors)
//     if (message) { return message }
//   } catch (err) { /* not JSON — fall through to the raw body */ }
//   return (body || "").trim() || "Download failed. Please try again."
// }
//
// // Downloads an authenticated file endpoint (report CSVs, exports) to the user's disk.
// //
// // A bare `window.location = url` navigation carries no Authorization header. Every backend
// // endpoint now authenticates by default (billebot's ApplicationController has a blanket
// // `before_action :authenticate_auth_user!`), so such a navigation answers 401 with a
// // plain-text body under a `text/csv` content type — which the browser reports as
// // ERR_INVALID_RESPONSE rather than as a session problem. Fetch the bytes with the token
// // and hand the browser a blob instead.
// //
// // `fallbackFilename` is only used when the server's own Content-Disposition is unreadable.
// export const doAuthenticatedDownloadFile = (
//   endpoint,
//   fallbackFilename = "download",
//   callback = {}
// ) => {
//   fetch(API_PATH(endpoint), {
//     method:  "GET",
//     mode:    "cors",
//     cache:   "no-cache",
//     headers: { "Authorization": getBearerToken() },
//   })
//   .then(res => {
//     if (res.status === 401) {
//       removeAuthToken()
//       window.location = getSessionExpiredRedirect()
//       return null
//     }
//     if (!res.ok) {
//       // These endpoints refuse with a body worth reading — a report answers 422 with
//       // {"error": "The selected firm(s) do not have existing data..."}. A navigation used
//       // to put that text on screen; a fetch would swallow it, so report it here when the
//       // caller has no handler of its own.
//       return res.text().then(body => {
//         if (callback.error) { callback.error(res, body) } else { alert(downloadErrorMessage(body)) }
//         return null
//       })
//     }
//     const filename = filenameFromResponse(res, fallbackFilename)
//     return res.blob().then(blob => ({ blob, filename }))
//   })
//   .then(result => {
//     if (!result) { return }
//     saveBlob(result.blob, result.filename)
//     if (callback.success) { callback.success() }
//   })
//   .catch(err => {
//     if (callback.catch) { callback.catch(err) }
//   })
// }

export const addTimestamp = (endpoint) => {
  const ts = `t=${(new Date).getTime()}`;
  const sep = endpoint.includes("?") ? '&' : '?';
  return endpoint + sep + ts;
}

export const addQueryString = (endpoint, params) => {
  try {
    const qs = Object.keys(params).map(key => key + '=' + params[key]).join('&');
    const sep = endpoint.includes("?") ? '&' : '?';
    return (qs == '') ? endpoint : endpoint + sep + qs;
  } catch(err) {
    return endpoint
  }

}

export const doAuthenticatedGetPromise = (endpoint) => {
  return new Promise((resolve, reject) => {
    const callback = {
      success: (response) => resolve(response),
      error: (error) => reject(error),
      general: (response) => resolve(response),
    };

    doAuthenticatedGet(endpoint, {}, callback);
  });
};